'use client';
import { notFound } from 'next/navigation';

import AllMatches from '@/modules/league/new-components/change-scores-components/AllMatches';
import { CompletedMatch, GameDayInfo } from '@/modules/league/new-components/types';
import { Session } from '@/types/types';

interface ChangeScoresWrapperProps {
  headerContent: GameDayInfo;
  user?: Session;
  completedMatches: CompletedMatch[];
  params: { slug: string; sessionId: string; matchDateId: string };
  isAuthorized: boolean;
}

const AllMatchesWrapper = ({
  params,
  headerContent,
  isAuthorized,
  completedMatches,
}: ChangeScoresWrapperProps) => {
  if (!isAuthorized) return notFound();

  return (
    <div className='md:gap-3pt-11 mx-auto h-auto w-full max-w-screen-xl gap-8 md:flex lg:w-4/5'>
      <div className='mx-auto h-auto w-full lg:max-w-full lg:gap-[24px]'>
        <AllMatches
          headerContent={headerContent}
          completedMatches={completedMatches}
          isAuthorized={isAuthorized}
          params={params}
        />
      </div>
    </div>
  );
};

export default AllMatchesWrapper;
